import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import VuexPersistence from "vuex-persist";
import usuariosService from "../services/UsuariosService";
import apuestasService from "../services/ApuestasService";
import cuentaService from "../services/CuentaService";
import textosService from "../services/TextosService";
import opcionesService from "../services/OpcionesService";
import currency from "currency.js";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

const sesion = {
  usuario: {},
  advertenciaRegistro: "",
  mensajeErrorRegistro: "",
  mensajeErrorLogin: "",
  mensajeErrorCambioContrasena: ""
};

const olvideMiContrasena = {
  emailRecuperacionContrasena: "",
  mensajeError: ""
};

const apuestaActual = {
  carreras: [],
  carreraSeleccionada: null,

  tiposApuestas: [],
  tipoApuestaSeleccionada: null,

  competidores: [],

  pases: [],
  paseSeleccionado: 0,
  textoApuesta: " ",
  cantidadItems: 0,
  cantidadVales: 0,
  importeApuesta: 0,
  importeImpuestos: 0,
  importeBonificacion: 0,
  importeComision: 0,
  importeTotal: 0,
  numeroTicket: 0,
  botonIngresarActivado: false,
  fechaHora: "",
  mensajeErrorApuesta: ""
};

const recarga = {
  codigoOperacion: "",
  mensajeErrorRecarga: ""
};

const retiro = {
  codigoOperacion: "",
  mensajeErrorRetiro: ""
};

const recargaMercadoPago = {
  initPoint: ""
};

const historial = {
  ultimosMovimientos: [],
  mensajeErrorHistorial: ""
};

const resultados = {
  carreras: [],
  carreraSeleccionada: {
    id: null,
    ganador1: null,
    place1: null,
    place2: null,
    tercero1: null,
    tercero2: null,
    tercero3: null,
    sports: []
  }
};

const textos = {
  retiro: ""
};

const actualizarDatosPersonales = {
  apellido: "",
  nombre: "",
  numeroDni: "",
  telefono: "",
  fotoDni: ""
};

const initialState = {
  sesion,
  olvideMiContrasena,
  apuestaActual,
  recarga,
  retiro,
  recargaMercadoPago,
  historial,
  resultados,
  textos,
  actualizarDatosPersonales
};

export default new Vuex.Store({
  state: initialState,
  actions: {
    loginExitoso({ commit }, { data }) {
      commit("loginExitoso", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    registro({ commit }, { email, hashContrasena, apellido, nombre, dni, telefono, apiToken }) {
      const ip = this.state.ip;
      usuariosService.registro(email, hashContrasena, apellido, nombre, telefono, dni, ip, apiToken, response => {
        if (response.data.resultado === "OK") {
          commit("registroExito", response.data);
          router.push("/registroExitoso");
        } else {
          commit("registroError", response.data);
        }
      });
    },
    obtenerAdvertenciaRegistro({ commit }, { apiToken }) {
      textosService.obtenerTextoAppAnonimo("MSG_REGISTRO", apiToken, response => {
        if (response.data.resultado === "OK") {
          commit("obtenerAdvertenciaRegistroExito", response.data);
        } else {
          commit("obtenerAdvertenciaRegistroError", response.data);
        }
      });
    },
    cambiarContrasena({ commit }, { hashContrasenaAnterior, hashContrasenaNueva }) {
      const token = this.state.sesion.usuario.token;
      usuariosService.cambiarContrasena(hashContrasenaAnterior, hashContrasenaNueva, token, response => {
        if (response.data.resultado === "OK") {
          commit("cambioContrasenaExito");
        } else {
          commit("cambioContrasenaError", response.data);
        }
        router.push("/miCuenta/cambiarContrasena/resultadoCambiarContrasena");
      });
    },
    iniciarRecuperacionContrasena({ commit }) {
      commit("limpiarRecuperacionContrasena");
    },
    enviarMailRecuperacionContrasena({ commit }, { email, apiToken }) {
      usuariosService.enviarMailRecuperacionContrasena(email, apiToken, response => {
        if (response.data.resultado === "OK") {
          commit("envioMailRecuperacionContrasenaExito", email);
          router.push("/olvideMiContrasena/ingresarCodigo");
        } else {
          commit("envioMailRecuperacionContrasenaError", response.data);
        }
      });
    },
    verificarCodigoRecuperacionContrasena({ commit }, { codigo, apiToken }) {
      const email = this.state.olvideMiContrasena.emailRecuperacionContrasena;
      usuariosService.verificarCodigoRecuperacionContrasena(email, codigo, apiToken, response => {
        if (response.data.resultado === "OK") {
          commit("verificarCodigoRecuperacionContrasenaExito", codigo);
          router.push("/olvideMiContrasena/nuevaContrasena");
        } else {
          commit("verificarCodigoRecuperacionContrasenaError", response.data);
        }
      });
    },
    cambiarContrasenaOlvidada({ commit }, { hashContrasena, apiToken }) {
      const email = this.state.olvideMiContrasena.emailRecuperacionContrasena;
      const codigo = this.state.olvideMiContrasena.codigoRecuperacion;
      usuariosService.cambiarContrasenaOlvidada(email, codigo, hashContrasena, apiToken, response => {
        if (response.data.resultado === "OK") {
          commit("cambiarContrasenaOlvidadaExito", codigo);
        } else {
          commit("cambiarContrasenaOlvidadaError", response.data);
        }
        router.push("/olvideMiContrasena/resultado");
      });
    },
    refrescarSaldo({ commit }) {
      const token = this.state.sesion.usuario.token;
      cuentaService.obtenerSaldo(token, response => {
        if (response.data.resultado === "OK") {
          commit("saldoRefrescadoExito", response.data);
        } else {
          commit("saldoRefrescadoError", response.data);
        }
      });
    },
    cargarCarreras({ commit }) {
      commit("limpiarApuesta");
      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerCarreras(token, response => {
        if (response.data.resultado === "OK") {
          commit("cargaCarrerasExitosa", response.data);
        } else {
          commit("cargaCarrerasError", response.data);
        }
      });
    },
    carreraSeleccionadaApuesta({ commit }, { carreraId }) {
      commit("carreraSeleccionadaApuesta", carreraId);
    },
    cargarTiposApuestas({ commit }) {
      const carreraId = this.state.apuestaActual.carreraSeleccionada.id;
      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerTiposApuestas(carreraId, token, response => {
        if (response.data.resultado === "OK") {
          commit("cargaTiposApuestasExitosa", response.data);
        } else {
          commit("cargaTiposApuestasError", response.data);
        }
      });
    },
    tipoApuestaSeleccionada({ commit }, { tipoApuestaId }) {
      commit("tipoApuestaSeleccionada", tipoApuestaId);
    },
    cargarCompetidores({ commit }) {
      const carreraId = this.state.apuestaActual.carreraSeleccionada.id;
      const tipoApuestaId = this.state.apuestaActual.tipoApuestaSeleccionada.id;
      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerCompetidores(carreraId, tipoApuestaId, token, response => {
        if (response.data.resultado === "OK") {
          commit("cargaCompetidoresExitosa", response.data);
        } else {
          commit("cargaCompetidoresError", response.data);
        }
      });
    },
    agregarCaballoApuesta({ commit }, { numero, pase }) {
      commit("agregarCaballoApuesta", { numero, pase });
    },
    quitarCaballoApuesta({ commit }, { numero, pase }) {
      commit("quitarCaballoApuesta", { numero, pase });
    },
    calcularCantidadItemsApuesta({ commit }) {
      const carreraId = this.state.apuestaActual.carreraSeleccionada.id;
      const tipoApuestaId = this.state.apuestaActual.tipoApuestaSeleccionada.id;
      const pases = this.state.apuestaActual.pases.map(c => c.join(" "));
      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerCantidadItems(carreraId, tipoApuestaId, pases, token, response => {
        if (response.data.resultado === "OK") {
          commit("calcularCantidadItemsApuestaExito", response.data);
        } else {
          commit("calcularCantidadItemsApuestaError", response.data);
        }
      });
    },
    iniciarPantallaVales({ commit }) {
      commit("iniciarPantallaVales");
    },
    setCantidadValesApuesta({ commit }, { cantidadVales }) {
      commit("setCantidadValesApuesta", cantidadVales);
    },
    ingresarApuesta({ commit }) {
      const carreraId = this.state.apuestaActual.carreraSeleccionada.id;
      const tipoApuestaId = this.state.apuestaActual.tipoApuestaSeleccionada.id;
      const pases = this.state.apuestaActual.pases.map(c => c.join(" "));
      const cantidadVales = parseInt(this.state.apuestaActual.cantidadVales);
      const token = this.state.sesion.usuario.token;

      if (cantidadVales == 0) {
        commit("cantidadValesInvalida");
        return;
      }

      commit("inicioIngresoApuesta");
      apuestasService.ingresarApuesta(carreraId, tipoApuestaId, pases, cantidadVales, token, response => {
        if (response.data.resultado === "OK") {
          const data = response.data;
          commit("ingresarApuestaExito", { apuestaId: data.apuestaId, numeroTicket: data.numeroTicket, fechaHora: data.fechaHora });
          router.push("/ticket");
        } else {
          commit("ingresarApuestaError", response.data);
        }
      });
    },
    eliminarDatosApuestaActual({ commit }) {
      commit("eliminarDatosApuestaActual");
    },
    generarSolicitudRecargaVentanilla({ commit }, { importe, medio }) {
      const token = this.state.sesion.usuario.token;
      cuentaService.generarSolicitudRecarga(importe, medio, token, response => {
        if (response.data.resultado === "OK") {
          commit("recargaVentanillaExito", { response: response.data, medio });
        } else {
          commit("recargaVentanillaError", response.data);
        }
        router.push("/micuenta/recarga/codigoRecarga");
      });
    },
    generarSolicitudRecargaBanco({ commit }, { importe, medio }) {
      const token = this.state.sesion.usuario.token;
      cuentaService.generarSolicitudRecarga(importe, medio, token, response => {
        if (response.data.resultado === "OK") {
          commit("recargaBancoExito", { response: response.data, medio });
        } else {
          commit("recargaBancoError", response.data);
        }
        router.push("/micuenta/recarga/datosTransferencia");
      });
    },
    generarSolicitudRetiro({ commit }) {
      const token = this.state.sesion.usuario.token;
      cuentaService.generarSolicitudRetiro(token, response => {
        if (response.data.resultado === "OK") {
          commit("retiroExito", response.data);
        } else {
          commit("retiroError", response.data);
        }
      });
    },
    generarRecargaMercadopago({ commit }, { importe }) {
      const token = this.state.sesion.usuario.token;
      cuentaService.generarRecargaMercadopago(importe, token, response => {
        if (response.data.resultado === "OK") {
          commit("recargaMercadoPagoExito", response.data);
        } else {
          commit("recargaMercadoPagoError", response.data);
        }
        router.push("/micuenta/recarga/mercadoPago");
      });
    },
    recargaConfirmada({ commit }, { saldo }) {
      commit("recargaConfirmada", { ...saldo });
    },
    obtenerUltimosMovimientos({ commit }, { dias }) {
      const token = this.state.sesion.usuario.token;
      cuentaService.obtenerUltimosMovimientos(dias, token, response => {
        if (response.data.resultado === "OK") {
          commit("obtenerUltimosMovimientosExito", { ...response.data });
        } else {
          commit("obtenerUltimosMovimientosError", { ...response.data });
        }
      });
    },
    cargarCarrerasResultado({ commit }) {
      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerCarrerasResultado(token, response => {
        if (response.data.resultado === "OK") {
          commit("cargaCarrerasResultadoExitosa", response.data);
        } else {
          commit("cargaCarrerasResultadoError", response.data);
        }
      });
    },
    cargarSportsCarrera({ commit }, { carreraId }) {
      commit("setCarreraResultadoSeleccionada", carreraId);

      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerSportsCarrera(carreraId, token, response => {
        if (response.data.resultado === "OK") {
          commit("obtenerSportsCarreraExito", response.data);
        } else {
          commit("obtenerSportsCarreraError", response.data);
        }
      });
    },
    cargarApuestaSeleccionadaHistorial({ commit }, { id }) {
      const token = this.state.sesion.usuario.token;
      apuestasService.obtenerApuesta(id, token, response => {
        if (response.data.resultado === "OK") {
          commit("cargarApuestaSeleccionadaHistorialExito", response.data);
        } else {
          commit("cargarApuestaSeleccionadaHistorialError", response.data);
        }
        router.push("/mostrarApuesta");
      });
    },
    anularApuesta({ commit }, { id }) {
      const token = this.state.sesion.usuario.token;
      apuestasService.anularApuesta(id, token, response => {
        if (response.data.resultado === "OK") {
          commit("anularApuestaExito", response.data);
        } else {
          commit("anularApuestaError", response.data);
        }
        router.push("/resultadoAnulacion");
      });
    },
    obtenerTextoAppRecargaTransferencia({ commit }) {
      const token = this.state.sesion.usuario.token;
      textosService.obtenerTextoApp("MSG_RECARGA_TRANS", token, response => {
        if (response.data.resultado === "OK") {
          commit("obtenerTextoAppRecargaTransferenciaExito", response.data);
        } else {
          commit("obtenerTextoAppRecargaTransferenciaError", response.data);
        }
      });
    },
    obtenerTextoAppRetiro({ commit }) {
      const token = this.state.sesion.usuario.token;
      textosService.obtenerTextoApp("MSG_RETIRO", token, response => {
        if (response.data.resultado === "OK") {
          commit("obtenerTextoAppRetiroExito", response.data);
        } else {
          commit("obtenerTextoAppRetiroError", response.data);
        }
      });
    },
    limpiarCredenciales({ commit }) {
      commit("limpiarCredenciales");
    },
    obtenerUrlsCanalesTransmision({ commit }) {
      const token = this.state.sesion.usuario.token;
      opcionesService.obtenerUrlsCanalesTransmision(token, response => {
        if (response.data.resultado === "OK") {
          commit("actualizarUrlsCanalesTransmision", response.data);
        }
      });
    },
    obtenerFotoDni({ commit }) {
      const token = this.state.sesion.usuario.token;
      usuariosService.obtenerFotoDni(token, response => {
        if (response.data.resultado === "OK") {
          commit("guardarFotoDni", response.data);
        }
      });
    },
    llenarBufferDatosPersonales({ commit }) {
      commit("llenarBufferDatosPersonales");
      router.push("/miCuenta/datosPersonales/actualizar");
    },
    dni({ commit }, datosPersonales) {
      commit("guardarDatosPersonalesTemporalmente", datosPersonales);
      router.push("/miCuenta/datosPersonales/dni");
    },
    guardarFotoTemporalDni({ commit, state }, { contenido }) {
      commit("guardarFotoTemporalDni", contenido);
      if (state.actualizarDatosPersonales.origen === "Interno") {
        router.push("/miCuenta/datosPersonales/actualizar");
      } else {
        router.push("/actualizacionExterna/actualizar");
      }
    },
    actualizarDatosPersonales({ commit }) {
      const token = this.state.sesion.usuario.token;
      const apellido = this.state.actualizarDatosPersonales.apellido;
      const nombre = this.state.actualizarDatosPersonales.nombre;
      const dni = this.state.actualizarDatosPersonales.dni;
      const telefono = this.state.actualizarDatosPersonales.telefono;
      const fotoDni = this.state.actualizarDatosPersonales.fotoDni;
      usuariosService.actualizarDatosPersonales("", apellido, nombre, dni, telefono, fotoDni, token, response => {
        if (response.data.resultado === "OK") {
          commit("actualizarDatosPersonalesExito");
          router.push("/menu");
        } else {
          commit("actualizarDatosPersonalesError", response.data.mensaje);
        }
      });
    },
    actualizarDatosPersonalesExterno({ commit }) {
      const tokenUsuario = this.state.actualizarDatosPersonales.token;
      const email = this.state.actualizarDatosPersonales.email;
      const apellido = this.state.actualizarDatosPersonales.apellido;
      const nombre = this.state.actualizarDatosPersonales.nombre;
      const dni = this.state.actualizarDatosPersonales.dni;
      const telefono = this.state.actualizarDatosPersonales.telefono;
      const fotoDni = this.state.actualizarDatosPersonales.fotoDni;

      usuariosService.actualizarDatosPersonalesExterno(tokenUsuario, email, apellido, nombre, dni, telefono, fotoDni, response => {
        if (response.data.resultado === "OK") {
          commit("actualizarDatosPersonalesExternoExito");
          router.push("/actualizacionExterna/exito");
        } else {
          commit("actualizarDatosPersonalesExternoError", response.data.mensaje);
        }
      });
    }
  },
  mutations: {
    loginExitoso(state, data) {
      state.sesion.usuario = data;
    },
    registroExito(state) {
      state.sesion.mensajeErrorRegistro = "";
    },
    registroError(state, data) {
      state.sesion.mensajeErrorRegistro = data.mensaje;
    },
    obtenerAdvertenciaRegistroExito(state, data) {
      state.sesion.advertenciaRegistro = data.texto;
    },
    obtenerAdvertenciaRegistroError(state, data) {
      state.sesion.mensajeErrorRegistro = data.mensaje;
    },
    cambioContrasenaExito(state) {
      state.mensajeErrorCambioContrasena = "";
    },
    cambioContrasenaError(state, data) {
      state.mensajeErrorCambioContrasena = data.mensaje;
    },
    limpiarRecuperacionContrasena(state) {
      state.olvideMiContrasena.emailRecuperacionContrasena = "";
      state.olvideMiContrasena.codigoRecuperacion = null;
      state.olvideMiContrasena.mensajeErrorEmail = "";
      state.olvideMiContrasena.mensajeErrorCodigo = "";
      state.olvideMiContrasena.mensajeErrorCambioContrasena = "";
    },
    envioMailRecuperacionContrasenaExito(state, email) {
      state.olvideMiContrasena.emailRecuperacionContrasena = email;
      state.olvideMiContrasena.mensajeErrorEmail = "";
      state.olvideMiContrasena.mensajeErrorCodigo = "";
    },
    envioMailRecuperacionContrasenaError(state, data) {
      state.olvideMiContrasena.mensajeErrorEmail = data.mensaje;
    },
    verificarCodigoRecuperacionContrasenaExito(state, codigo) {
      state.olvideMiContrasena.codigoRecuperacion = codigo;
      state.olvideMiContrasena.mensajeErrorCodigo = "";
    },
    verificarCodigoRecuperacionContrasenaError(state, data) {
      state.olvideMiContrasena.mensajeErrorCodigo = data.mensaje;
    },
    cambiarContrasenaOlvidadaExito(state, codigo) {
      state.olvideMiContrasena.emailRecuperacionContrasena = "";
      state.olvideMiContrasena.codigoRecuperacion = codigo;
      state.olvideMiContrasena.mensajeErrorEmail = "";
      state.olvideMiContrasena.mensajeErrorCodigo = "";
      state.olvideMiContrasena.mensajeErrorCambioContrasena = "";
    },
    cambiarContrasenaOlvidadaError(state, data) {
      state.olvideMiContrasena.mensajeErrorCambioContrasena = data.mensaje;
    },
    logout(state) {
      state.sesion.usuario = null;
    },
    saldoRefrescadoExito(state, data) {
      state.sesion.usuario.saldo = data.saldo;
      state.mensajeErrorUltimaOperacion = "";
    },
    saldoRefrescadoError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    limpiarApuesta(state) {
      state.apuestaActual.mensajeErrorApuesta = "";
    },
    cargaCarrerasExitosa(state, data) {
      state.apuestaActual.carreras = data.carreras;
    },
    cargaCarrerasError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    carreraSeleccionadaApuesta(state, carreraId) {
      state.apuestaActual.carreraSeleccionada = state.apuestaActual.carreras.find(c => c.id == carreraId);
    },
    cargaTiposApuestasExitosa(state, data) {
      state.apuestaActual.tiposApuestas = data.tiposApuestas;
    },
    cargaTiposApuestasError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    tipoApuestaSeleccionada(state, tipoApuestaId) {
      state.apuestaActual.tipoApuestaSeleccionada = state.apuestaActual.tiposApuestas.find(c => c.id == tipoApuestaId);
    },
    cargaCompetidoresExitosa(state, data) {
      state.apuestaActual.competidores = data.carreras;
      state.apuestaActual.pases = [];
      state.apuestaActual.paseSeleccionado = 0;
      switch (state.apuestaActual.tipoApuestaSeleccionada.id) {
        case "GA":
        case "PL":
        case "TE":
        case "GS":
        case "GT":
        case "EC":
        case "IC":
        case "TC":
        case "CC":
        case "QC":
          state.apuestaActual.pases[0] = [];
          break;
        case "EX":
        case "IM":
        case "DB":
          state.apuestaActual.pases[0] = [];
          state.apuestaActual.pases[1] = [];
          break;
        case "TR":
        case "TP":
        case "3E":
          state.apuestaActual.pases[0] = [];
          state.apuestaActual.pases[1] = [];
          state.apuestaActual.pases[2] = [];
          break;
        case "CU":
        case "PK":
        case "4E":
          state.apuestaActual.pases[0] = [];
          state.apuestaActual.pases[1] = [];
          state.apuestaActual.pases[2] = [];
          state.apuestaActual.pases[3] = [];
          break;
        case "QX":
        case "QT":
          state.apuestaActual.pases[0] = [];
          state.apuestaActual.pases[1] = [];
          state.apuestaActual.pases[2] = [];
          state.apuestaActual.pases[3] = [];
          state.apuestaActual.pases[4] = [];
          break;
        case "56":
          state.apuestaActual.pases[0] = [];
          state.apuestaActual.pases[1] = [];
          state.apuestaActual.pases[2] = [];
          state.apuestaActual.pases[3] = [];
          state.apuestaActual.pases[4] = [];
          state.apuestaActual.pases[5] = [];
          break;
      }
      state.apuestaActual.textoApuesta = " ";
    },
    cargaCompetidoresError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    agregarCaballoApuesta(state, data) {
      state.apuestaActual.pases[data.pase].push(data.numero);
      const textosPases = state.apuestaActual.pases.map(c => c.join(" "));
      state.apuestaActual.textoApuesta = " " + textosPases.join(" / ");
    },
    quitarCaballoApuesta(state, data) {
      state.apuestaActual.pases[data.pase].pop();
      const textosPases = state.apuestaActual.pases.map(c => c.join(" "));
      state.apuestaActual.textoApuesta = textosPases.join(" / ");
    },
    calcularCantidadItemsApuestaExito(state, data) {
      state.apuestaActual.cantidadItems = data.cantidadItems;
    },
    calcularCantidadItemsApuestaError(state, data) {
      state.apuestaActual.mensajeErrorApuesta = data.mensaje;
    },
    iniciarPantallaVales(state) {
      state.apuestaActual.botonIngresarActivado = true;
      state.apuestaActual.cantidadVales = 0;
      state.apuestaActual.mensajeErrorApuesta = "";
    },
    setCantidadValesApuesta(state, cantidadVales) {
      state.apuestaActual.cantidadVales = cantidadVales;
      const importeApuesta = state.apuestaActual.cantidadItems * state.apuestaActual.cantidadVales * state.apuestaActual.tipoApuestaSeleccionada.valorVale;
      state.apuestaActual.importeApuesta = importeApuesta;

      if (state.apuestaActual.carreraSeleccionada.aplicaImpuesto) {
        state.apuestaActual.importeImpuestos = currency(importeApuesta).multiply(currency(state.sesion.usuario.impuesto));
      } else {
        state.apuestaActual.importeImpuestos = currency(0);
      }

      if (cantidadVales >= state.apuestaActual.tipoApuestaSeleccionada.minimoConBonificacion) {
        state.apuestaActual.importeBonificacion = currency(importeApuesta).multiply(currency(state.sesion.usuario.bonificacion));
      } else {
        state.apuestaActual.importeBonificacion = currency(0);
      }

      if (
        cantidadVales < state.apuestaActual.tipoApuestaSeleccionada.minimoSinComision &&
        !state.apuestaActual.carreraSeleccionada.sinComision &&
        state.apuestaActual.carreraSeleccionada.hipodromoAplicaComision
      ) {
        state.apuestaActual.importeComision = currency(importeApuesta).multiply(currency(state.sesion.usuario.comision));
      } else {
        state.apuestaActual.importeComision = currency(0);
      }

      state.apuestaActual.importeTotal = currency(importeApuesta)
        .add(state.apuestaActual.importeImpuestos)
        .subtract(state.apuestaActual.importeBonificacion)
        .add(state.apuestaActual.importeComision);
    },
    cantidadValesInvalida(state) {
      state.apuestaActual.mensajeErrorApuesta = "Cantidad de vales inválida";
    },
    inicioIngresoApuesta(state) {
      state.apuestaActual.mensajeErrorApuesta = "";
      state.apuestaActual.botonIngresarActivado = false;
    },
    ingresarApuestaExito(state, data) {
      state.apuestaActual.mensaje = "Apuesta cargada exitosamente";
      state.apuestaActual.apuestaId = data.apuestaId;
      state.apuestaActual.numeroTicket = data.numeroTicket;
      state.apuestaActual.fechaHora = data.fechaHora;
      state.apuestaActual.botonIngresarActivado = true;
      state.sesion.usuario.saldo = currency(state.sesion.usuario.saldo).subtract(state.apuestaActual.importeTotal);
    },
    ingresarApuestaError(state, data) {
      state.apuestaActual.mensajeErrorApuesta = data.mensaje;
      state.apuestaActual.botonIngresarActivado = true;
    },
    eliminarDatosApuestaActual(state) {
      state.apuestaActual.carreraId = null;
      state.apuestaActual.apuestaId = null;
      state.apuestaActual.importeTotal = 0;
    },
    recargaVentanillaExito(state, data) {
      state.recarga.resultado = "OK";
      state.recarga.codigoOperacion = data.response.codigoOperacion;
      state.recarga.medio = data.medio;
      state.recarga.urlMercadoPago = data.response.urlMercadoPago;
    },
    recargaVentanillaError(state, response) {
      state.recarga.resultado = "ERROR";
      state.mensajeErrorUltimaOperacion = response.mensaje;
    },
    recargaBancoExito(state, data) {
      state.recarga.resultado = "OK";
      state.recarga.codigoOperacion = data.response.codigoOperacion;
      state.recarga.medio = data.medio;
    },
    recargaBancoError(state, response) {
      state.recarga.resultado = "ERROR";
      state.recarga.mensaje = response.mensaje;
    },
    retiroExito(state, data) {
      state.retiro.resultado = "OK";
      state.retiro.codigoOperacion = data.codigoOperacion;
    },
    retiroError(state, response) {
      state.retiro.resultado = "ERROR";
      state.retiro.mensaje = response.mensaje;
    },
    recargaMercadoPagoExito(state, data) {
      state.recargaMercadoPago.initPoint = data.initPoint;
      state.recargaMercadoPago.mensaje = "";
    },
    recargaMercadoPagoError(state, data) {
      state.recargaMercadoPago.initPoint = "";
      state.recargaMercadoPago.mensaje = data.mensaje;
    },
    obtenerUltimosMovimientosExito(state, data) {
      state.historial.ultimosMovimientos = data.ultimosMovimientos;
      state.historial.mensajeError = "";
    },
    obtenerUltimosMovimientosError(state, data) {
      state.historial.ultimosMovimientos = null;
      state.historial.mensajeError = data.mensaje;
    },
    anularApuestaExito(state, data) {
      state.sesion.usuario.saldo = data.nuevoSaldo;
      state.mensajeErrorUltimaOperacion = "";
    },
    anularApuestaError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    obtenerTextoAppRecargaTransferenciaExito(state, data) {
      state.textos.recargaTransferencia = data.texto;
      state.mensajeErrorUltimaOperacion = "";
    },
    obtenerTextoAppRecargaTransferenciaError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    obtenerTextoAppRetiroExito(state, data) {
      state.textos.retiro = data.texto;
      state.mensajeErrorUltimaOperacion = "";
    },
    obtenerTextoAppRetiroError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    recargaConfirmada(state, data) {
      state.sesion.usuario.saldo = data.saldo;
      state.recarga.codigoOperacion = "";
    },
    cargaCarrerasResultadoExitosa(state, data) {
      state.resultados.carreras = data.carreras;
      state.mensajeErrorUltimaOperacion = "";
    },
    cargaCarrerasResultadoError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    carreraResultadoSeleccionada(state, data) {
      state.resultados.carreraSeleccionadaId = data;
    },
    setCarreraResultadoSeleccionada(state, carreraId) {
      state.resultados.carreraSeleccionada.id = carreraId;
    },
    obtenerSportsCarreraExito(state, data) {
      state.resultados.carreraSeleccionada.posicion1 = data.sportPosicion1;
      state.resultados.carreraSeleccionada.posicion2 = data.sportPosicion2;
      state.resultados.carreraSeleccionada.posicion3 = data.sportPosicion3;
      state.resultados.carreraSeleccionada.posicion4 = data.sportPosicion4;
      state.resultados.carreraSeleccionada.posicion5 = data.sportPosicion5;
      state.resultados.carreraSeleccionada.posicion6 = data.sportPosicion6;
      state.resultados.carreraSeleccionada.ganador1 = data.sportGanador;
      state.resultados.carreraSeleccionada.place1 = data.sportPlace1;
      state.resultados.carreraSeleccionada.place2 = data.sportPlace2;
      state.resultados.carreraSeleccionada.tercero1 = data.sportTercero1;
      state.resultados.carreraSeleccionada.tercero2 = data.sportTercero2;
      state.resultados.carreraSeleccionada.tercero3 = data.sportTercero3;
      state.resultados.carreraSeleccionada.sports = data.sportsCarrera.map(function(c) {
        return {
          tipoApuestaId: c.tipoApuestaId,
          orden: c.orden,
          posiciones: [c.posicion1, c.posicion2, c.posicion3, c.posicion4, c.posicion5, c.posicion6].filter(Boolean).join("/"),
          pago: c.pago
        };
      });
      state.resultados.carreraSeleccionada.jockey = data.jockey;
      state.resultados.carreraSeleccionada.ganadaPor = data.ganadaPor;
      state.mensajeErrorUltimaOperacion = "";
    },
    obtenerSportsCarreraError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    cargarApuestaSeleccionadaHistorialExito(state, data) {
      state.historial.apuestaSeleccionada = data.apuesta;
      state.mensajeErrorUltimaOperacion = "";
    },
    cargarApuestaSeleccionadaHistorialError(state, data) {
      state.mensajeErrorUltimaOperacion = data.mensaje;
    },
    limpiarCredenciales(state) {
      state.sesion.usuario.token = null;
    },
    actualizarUrlsCanalesTransmision(state, data) {
      state.urlsCanales = data.canales;
    },
    guardarFotoTemporalDni(state, data) {
      state.actualizarDatosPersonales.fotoDni = data;
    },
    guardarDatosPersonales(state, data) {
      state.actualizarDatosPersonales.email = data.email;
      state.actualizarDatosPersonales.apellido = data.apellido;
      state.actualizarDatosPersonales.nombre = data.nombre;
      state.actualizarDatosPersonales.dni = data.dni;
      state.actualizarDatosPersonales.telefono = data.telefono;
      state.actualizarDatosPersonales.origen = data.origen;
    },
    guardarFotoDni(state, data) {
      state.sesion.usuario.fotoDni = data.fotoDni;
    },
    llenarBufferDatosPersonales(state) {
      state.actualizarDatosPersonales.apellido = state.sesion.usuario.apellido;
      state.actualizarDatosPersonales.nombre = state.sesion.usuario.nombre;
      state.actualizarDatosPersonales.dni = state.sesion.usuario.dni;
      state.actualizarDatosPersonales.telefono = state.sesion.usuario.telefono;
    },
    guardarDatosPersonalesTemporalmente(state, data) {
      state.actualizarDatosPersonales.email = data.email;
      state.actualizarDatosPersonales.apellido = data.apellido;
      state.actualizarDatosPersonales.nombre = data.nombre;
      state.actualizarDatosPersonales.dni = data.dni;
      state.actualizarDatosPersonales.telefono = data.telefono;
      state.actualizarDatosPersonales.origen = data.origen;
    },
    actualizarDatosPersonalesExito(state) {
      state.sesion.usuario.apellido = state.actualizarDatosPersonales.apellido;
      state.sesion.usuario.nombre = state.actualizarDatosPersonales.nombre;
      state.sesion.usuario.dni = state.actualizarDatosPersonales.dni;
      state.sesion.usuario.telefono = state.actualizarDatosPersonales.telefono;
      state.sesion.usuario.fotoDni = state.actualizarDatosPersonales.fotoDni;
      state.sesion.usuario.actualizarDatosPersonales = false;

      state.actualizarDatosPersonales.apellido = "";
      state.actualizarDatosPersonales.nombre = "";
      state.actualizarDatosPersonales.dni = "";
      state.actualizarDatosPersonales.telefono = "";
      state.actualizarDatosPersonales.fotoDni = "";
    },
    actualizarDatosPersonalesError(state) {
      state.actualizarDatosPersonales.apellido = "";
      state.actualizarDatosPersonales.nombre = "";
      state.actualizarDatosPersonales.dni = "";
      state.actualizarDatosPersonales.telefono = "";
      state.actualizarDatosPersonales.fotoDni = "";
    },
    actualizarDatosPersonalesExternoExito(state) {
      state.actualizarDatosPersonales.email = "";
      state.actualizarDatosPersonales.token = "";
      state.actualizarDatosPersonales.apellido = "";
      state.actualizarDatosPersonales.nombre = "";
      state.actualizarDatosPersonales.dni = "";
      state.actualizarDatosPersonales.telefono = "";
      state.actualizarDatosPersonales.fotoDni = "";
    },
    actualizarDatosPersonalesExternoError(state) {
      state.actualizarDatosPersonales.mensajeError = "No se han podido actualizar los datos personales";
    },
    obtenerDatosPersonalesExternoExito(state, data) {
      state.actualizarDatosPersonales.token = data.token;
      state.actualizarDatosPersonales.email = data.email;
      state.actualizarDatosPersonales.apellido = data.apellido;
      state.actualizarDatosPersonales.nombre = data.nombre;
      state.actualizarDatosPersonales.dni = data.dni;
      state.actualizarDatosPersonales.telefono = data.telefono;
      state.actualizarDatosPersonales.fotoDni = data.fotoDni;
    },
    obtenerDatosPersonalesExternoError() {},
    imagenSubidaExito(state) {
      state.sesion.dni.ultimoError = "";
    },
    imagenSubidaError(state, data) {
      state.sesion.dni.ultimoError = data.mensaje;
    }
  },
  getters: {},
  modules: {},
  plugins: [vuexLocal.plugin]
});
